import React from 'react';

export interface Props {
  time: number;
  onEnd?: () => any;
}

const useCountdown = ({ time, onEnd = () => {} }: Props) => {
  const [elapsedTime, setElapsedTime] = React.useState(0);

  React.useEffect(() => {
    if (elapsedTime >= time) return onEnd();
    const intervalReference = setInterval(() => {
      setElapsedTime((time: number) => time + 1);
    }, 1000);

    return () => clearInterval(intervalReference);
  }, [elapsedTime]);

  const resetTimer = () => setElapsedTime(0);

  return { timeLeft: time - elapsedTime, resetTimer };
};

export default useCountdown;
